// extracted by mini-css-extract-plugin
module.exports = {"promotionLandingPage":"promotionLandingPage_promotionLandingPage__xMo-2","deliveryFlow":"promotionLandingPage_deliveryFlow__l1yf1"};